'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultParams = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Created by fanjingjian on 17/9/4.
                                                                                                                                                                                                                                                                   */

var _getCookie = require('./getCookie');

var _getCookie2 = _interopRequireDefault(_getCookie);

var _owl = require('./owl');

var _lx2hip = require('./config/lx2hip.config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 联盟/POI 落地页通用参数
 * @type {{pageId: string, emidasRequestId, hc: (any), type: string}}
 */
var defaultParams = exports.defaultParams = {
    pageId: '1', // 当前处于活动的第几页，目前只有一页
    emidasRequestId: function () {
        var code = new Date().getTime() + '_';
        var codeLength = 6;
        var selectChar = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'); //所有候选组成验证码的字符，当然也可以用中文的
        for (var i = 0; i < codeLength; i++) {
            var charIndex = Math.floor(Math.random() * 36);
            code += selectChar[charIndex];
        }
        return code;
    }(),
    hc: (0, _getCookie2.default)('_hc.v').replace(/\"\\\"/, '').replace(/\\\"\"/, '').replace(/.[\d]*$/, ''),
    type: 'emidas_activity',
    act_pv_uv_other: ''
};

/**
 * 闭包固定页面基础参数 返回点击打点方法
 * @param defaultLxParamsFromPageInfo 落地页配置的基础数据
 * @return {Function} 返回打点方法
 */
var moduleClick = function moduleClick(defaultLxParamsFromPageInfo) {

    var lx = window['LXAnalytics'];

    if (typeof lx !== 'function') {
        console.error('lx源文件未引入');
        return function () {};
    }

    var lxCustomParams = _extends({}, defaultParams, defaultLxParamsFromPageInfo);

    return function (bid, bidName, otherParams) {
        if (!bid) {
            console.error('打点 bid 缺失');
            return;
        }
        var custom = _extends({
            bidName: bidName || '用户行为'
        }, lxCustomParams, otherParams);

        try {
            lx('moduleClick', bid, { custom: custom });
        } catch (e) {
            console.error('lx打点异常', e);
            (0, _owl.emitAddError)(e, { errorMessage: 'lx打点异常', custom: custom, bidName: bidName });
        }
    };
};

/**
 * 向外暴露的点击点发送方法
 * @param alias {String} 方法别名，一般是落地页在 title 内，事先注册的数组，要求是 window 下的对象
 * @param defaultMVParams {Object} 页面配置的默认打点参数
 * @return {Array} 返回传入的打点方法所在对象，该对象挂载的 push 方法，是打点api
 */
var CPMLXInit = function CPMLXInit(alias, defaultMVParams, shopType, hip) {
    var _cplx = window[alias] || [];
    var lxModuleClick = moduleClick(defaultMVParams);

    var mapBUName = _lx2hip.BUInfo[String(shopType)];

    var hipMap = _extends({}, _lx2hip.mapLX2HipBase, _lx2hip.mapLX2HipSpecial[mapBUName]);

    if (Array.isArray(_cplx) && _cplx.length > 0) {
        _cplx.map(function (item) {
            lxModuleClick.apply(undefined, item);
        });
    }

    _cplx.push = function (params) {
        try {
            var bid = params[0] || '';
            var hipModule = hipMap[bid];
            if (hipModule) {
                hip.push(['mv', {
                    action: 'click',
                    module: hipModule
                }]);
            }
        } catch (e) {
            console.error('hip 打点异常：', e);
        }

        lxModuleClick.apply(undefined, params);
    };

    return _cplx;
};

exports.default = CPMLXInit;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cp-component-lib/lib/lxAndHipPolyfill.js
// module id = 241
// module chunks = 0